import React, { type FC } from 'react';

import type { PillProps } from './Pill.types';

import styles from './Styles/Pill.module.css';

export const Pill: FC<PillProps> = React.forwardRef<HTMLElement, PillProps>(
  (
    { children, leftIcon, dataTestId, Component = 'div', className = '', variant, ...restProps },
    ref,
  ) => {
    return (
      <Component
        className={`typography-subheading-3 ${styles.pill} ${
          variant === 'vehicle-spec' ? styles.vehicleSpec : ''
        } ${className}`.trim()}
        data-test-id={dataTestId}
        ref={ref}
        {...restProps}
      >
        {leftIcon && <span className={styles.leftIcon}>{leftIcon}</span>}
        {children}
      </Component>
    );
  },
);

Pill.displayName = 'Pill';

export default Pill;
